<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <v-layout>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text" v-if="tipeView != 'aprobacion'"
          >Datos Relator</v-toolbar-title
        >
      </v-toolbar>
    </v-layout>
    <v-layout>
      <v-flex xs12 md6>
        <v-text-field
          v-model="rut"
          label="Rut"
          counter="10"
          maxlength="10"
          :box="true"
          :readonly="true"
          :error-messages="rutErrors"
          @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex xs12 md6>
        <v-text-field
          v-model="nombre"
          label="Nombre"
          :box="true"
          :readonly="true"
          @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellido1"
          label="Primer Apellido"
          :box="true"
          :readonly="true"
          @input="$v.apellido1.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellido2"
          label="Segundo Apellido"
          :box="true"
          :readonly="true"
          @input="$v.apellido2.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido2.$touch() : null"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Datos Evaluador</v-toolbar-title
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md6>
        <v-text-field
          v-model="rutExaminador"
          label="Rut"
          counter="10"
          maxlength="10"
          :box="isDisabled"
          :readonly="isDisabled"
          :error-messages="rutErrors"
          @input="dvRut()"
          @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex xs12 md6>
        <v-text-field
          v-model="nombreExaminador"
          label="Nombre"
          :error-messages="nombreErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellidoExaminador1"
          label="Primer Apellido"
          :error-messages="apellidoErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.apellido1.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellidoExaminador2"
          label="Segundo Apellido"
          :error-messages="apellidoErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.apellido2.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido2.$touch() : null"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">Evaluación</v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fechaEvaluacion"
              label="Fecha Evaluación"
              :error-messages="fechaEvaluacionErrors"
              :box="isDisabled"
              :readonly="isDisabled"
              prepend-icon="event"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fechaEvaluacion"
            @input="menu1 = false"
            no-title
            locale="es"
            :box="isDisabled"
            :readonly="isDisabled"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <v-select
          v-model="evaluacionRelatoresValue"
          :items="evaluacionRelatoresSelect"
          item-text="nombre"
          item-value="code"
          :box="isDisabledselect"
          :readonly="isDisabledselect"
          :error-messages="selectErrors"
          label="Evaluación Obtenida"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-textarea
          v-model="detalleEvaluacion"
          solo
          :box="isDisabled"
          :readonly="isDisabled"
          name="input-7-4"
          label="Detalle las acciones preventivas o correctivas que se pueden aplicar al proceso de cada relator"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'consulta' ? false : true"
        color="primary"
        dark
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import { error } from "util";
export default {
  name: "evaluacion-relator-data",
  components: {},
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
    id: "",
  },
  data() {
    return {
      validacion: "",
      menu1: false,
      fechaNacimiento: "",
      allowSpaces: false,
      idContrato: "",
      descripcion: "",
      observacion: "",
      filenameValue: "",
      nombre: "",
      apellido1: "",
      apellido2: "",
      rut: "",
      nombreExaminador: "",
      apellidoExaminador1: "",
      apellidoExaminador2: "",
      rutExaminador: "",
      idRelatores: "",
      evaluacionRelatoresSelect: [],
      evaluacionRelatoresValue: "",
      fechaEvaluacion: "",
      tipoEvaluacion: "",
      detalleEvaluacion: "",
      code_error: "",
    };
  },

  validations: {
    nombreExaminador: { required },
    apellidoExaminador1: { required },
    apellidoExaminador2: { required },
    rut: { required },
    rutExaminador: { required },
    evaluacionRelatoresValue: { required },
    fechaEvaluacion: { required },
  },

  created() {
    this.user = this.$store.getters.userLogged.tipo;
    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta") {
      this.loadEvaluacionRelatores();
      this.loadData();
    }
    if (this.tipeView == "crear" || this.tipeView == "modifica") {
      this.loadEvaluacionRelatores();
      this.loadData();
    }
  },
  mounted() {
    this.idContrato = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombreExaminador.$dirty) return errors;
      !this.$v.nombreExaminador.required &&
        errors.push("Nombre es obligatorio.");
      return errors;
    },
    fechaEvaluacionErrors() {
      const errors = [];
      if (!this.$v.fechaEvaluacion.$dirty) return errors;
      !this.$v.fechaEvaluacion.required &&
        errors.push("Fecha de la evaluación es requerida");
      return errors;
    },
    apellidoErrors() {
      const errors = [];
      if (
        !this.$v.apellidoExaminador1.$dirty ||
        !this.$v.apellidoExaminador1.$dirty
      )
        return errors;
      !this.$v.apellidoExaminador1.required &&
        errors.push("Apellido es obligatorio.");
      !this.$v.apellidoExaminador1.required &&
        errors.push("Apellido es obligatorio.");
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.evaluacionRelatoresValue.$dirty) return errors;
      !this.$v.evaluacionRelatoresValue.required &&
        errors.push("Debe seleccionar la evaluación a calificar");
      return errors;
    },

    isDisabled() {
      if (this.tipeView == "consulta" || this.tipeView == "aprobacion") {
        return true;
      }
    },
    isDisabledSel() {
      if (this.tipeView == "modifica" || this.tipeView == "consulta") {
        return true;
      }
    },
    isDisabledRut() {
      if (this.tipeView == "modifica" || this.tipeView == "consulta") {
        return true;
      }
    },
    isDisabledselect() {
      if (this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
    },
    async loadData() {
      this.documento = await this.loadRelator();
      this.documentoEvaluacion = await this.loadEvaluacionRelator();
      this.nombre = this.documento.nombre;
      this.apellido1 = this.documento.apellido1;
      this.apellido2 = this.documento.apellido2;
      this.dv = this.documento.dv;
      this.rut = this.documento.rut + "-" + this.dv;
      this.fono = this.documento.telefono;
      this.email = this.documento.email;
      this.fechaNacimiento = this.documento.fechaNacimiento;
      this.direccion = this.documento.direccion;
      this.nombreExaminador = this.documentoEvaluacion.nombreExaminador;
      this.rutExaminador = this.formateaRut(
        this.documentoEvaluacion.rutExaminador
      );
      this.apellidoExaminador1 = this.documentoEvaluacion.apellidoExaminador1;
      this.apellidoExaminador2 = this.documentoEvaluacion.apellidoExaminador2;
      this.fechaEvaluacion = this.formatoFechaView(
        this.documentoEvaluacion.fechaEvaluacion
      );
      this.detalleEvaluacion = this.documentoEvaluacion.accionesPreventivas;
      this.evaluacionRelatoresValue =
        this.documentoEvaluacion.idResultadoEvaluacion;
    },
    async loadRelator() {
      let idContrato = this.$store.getters.contratoStored;
      let idRelator = this.id;
      return await axios
        .get("/relator/" + idRelator + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadEvaluacionRelator() {
      let idContrato = this.$store.getters.contratoStored;
      let idRelator = this.id;
      return await axios
        .get("/evaluacionRelator/" + idRelator + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    back() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoCapacitacion",
        });
      }, 1000);
    },
    save() {
      if (this.documentoEvaluacion.length == 0) {
        this.guardarEvaluacion();
      } else {
        this.editarEvaluacion();
      }
    },
    guardarEvaluacion() {
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let dv = this.obtenerDv(this.rutExaminador);
      let rut = this.obtenerSoloRut(this.rutExaminador);
      let v = this.validaRut(this.rutExaminador);
      let fecha = "";
      if (this.fechaEvaluacion != null) {
        fecha = this.formatoFecha(this.fechaEvaluacion);
      }
      if (v == false) {
        window.getApp.$emit("ERROR_RUT");
        this.location.reload();
      } else {
        this.body = {
          idContrato: idContrato,
          rutExaminador: rut + dv,
          idRelator: this.id,
          nombreExaminador: this.nombreExaminador,
          apellidoExaminador1: this.apellidoExaminador1,
          apellidoExaminador2: this.apellidoExaminador2,
          fechaEvaluacion: fecha,
          idResultadoEvaluacion: this.evaluacionRelatoresValue,
          accionesPreventivas: this.detalleEvaluacion,
        };
      }
      axios
        .post("/evaluacionRelator/create", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
        });
    },
    editarEvaluacion() {
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let dv = this.obtenerDv(this.rutExaminador);
      let rut = this.obtenerSoloRut(this.rutExaminador);
      let v = this.validaRut(this.rutExaminador);
      let fecha = "";
      if (this.fechaEvaluacion != null) {
        fecha = this.formatoFecha(this.fechaEvaluacion);
      }
      if (v == false) {
        window.getApp.$emit("ERROR_RUT");
        this.location.reload();
      } else {
        this.body = {
          idContrato: idContrato,
          rutExaminador: rut + dv,
          idRelator: this.id,
          nombreExaminador: this.nombreExaminador,
          apellidoExaminador1: this.apellidoExaminador1,
          apellidoExaminador2: this.apellidoExaminador2,
          fechaEvaluacion: fecha,
          idResultadoEvaluacion: this.evaluacionRelatoresValue,
          accionesPreventivas: this.detalleEvaluacion,
        };
      }
      axios
        .put("/evaluacionRelator/update", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
    async loadEvaluacionRelatores() {
      this.tipoEvaluacion = await this.loadTipoEvaluacion();
      let evaluacion = [];
      this.tipoEvaluacion.forEach(function (e) {
        evaluacion.push({
          nombre: e.descripcion,
          code: e.id,
        });
      });
      this.evaluacionRelatoresSelect = evaluacion;
    },

    async loadTipoEvaluacion() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
      };
      return await axios
        .post("/evaluacionRelator/tiposEvaluacion", this.body)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    formatoFecha(f) {
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    formatoFechaView(f) {
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
  },
};
</script>
